
const setuScroll = () => {
	'use strict';

	/**
	 * event to scroll by a click on the scroll-content-to html-element to his direction on html-attributes
	 */
	$(document).on('click', '.scroll-content-to', function() {
		var direction = jQuery(this).attr('data-direction');
		var elParent = jQuery(this).parent();
		var elContent = jQuery(this).parent().children('.scroll-content');
		var elHeight = jQuery(this).outerHeight();
		var elBoxHeight = jQuery(this).parent().height();
		var elContentHeight = jQuery(elContent).height();
		var rows = Math.round(elContentHeight / elBoxHeight);
		var scrollRow = (!!jQuery(elParent).attr('data-scroll-row')) ? jQuery(elParent).attr('data-scroll-row') : 0;
		var pos = 0;

		var scrollVertical = function(el, pos) {
			$(el).animate({top: pos});
		}
		var scrollHorizontal = function(el, pos) {
			$(el).animate({top: pos});
		}

		switch(direction) {
			case 'bottom':
				scrollRow++;
				pos = -((elBoxHeight - (elHeight * 3)) * scrollRow);
				scrollVertical(elContent, pos)
				$(elParent).children('.scroll-content-to[data-direction="top"]').show();
				if (rows <= 1 || scrollRow >= rows) {
					$(this).hide();
				}
				$(elParent).attr('data-scroll-row', scrollRow);
				break;

			case 'left':
				console.debug('is not defined');
				break;

			case 'right':
				console.debug('is not defined');
				break;

			case 'top':
				scrollRow--;
				pos = -((elBoxHeight - (elHeight * 3)) * scrollRow);
				scrollVertical(elContent, pos);
				$(elParent).children('.scroll-content-to[data-direction="bottom"]').show();
				if (rows <= 1 || scrollRow <= 0) {
					$(this).hide();
				}
				$(elParent).attr('data-scroll-row', scrollRow);
				break;
		}
	});


	$.fn.setuScrollDetectScrollBar = function(direction) {
		var calcSizes = function(element, direction) {
			var boxSize = 0;
			var boxContentSize = 0;

			if(direction === 'v') {
				boxSize = parseFloat($(element).height());
				boxContentSize = parseFloat($(element).children('.scroll-content').height() || 0) + parseFloat($(element).children('.scroll-content').css('margin-top') || 0) + parseFloat($(element).children('.scroll-content').css('margin-bottom') || 0);
			}
			else if(direction === 'h') {
				boxSize = parseFloat($(element).width());
				boxContentSize = parseFloat($(element).children('.scroll-content').width() || 0) + parseFloat($(element).children('.scroll-content').css('margin-left') || 0) + parseFloat($(element).children('.scroll-content').css('margin-right') || 0);
			}

			return {'boxSize': boxSize, 'boxContentSize': boxContentSize};
		}
		var sizes = calcSizes(this, direction);
		var _this = this;


		if(sizes.boxSize < sizes.boxContentSize) {
			if(direction === 'v') {
				if($(_this).find('.scroll-content-to[data-direction="bottom"]').length == 0) {
					$(_this).append('<div class="scroll-content-to" data-direction="bottom"><span class="glyphicons glyphicons-chevron-down"><span class="line"></span></span><span class="line"></span></div>')
				}
				else {
					$(_this).find('.scroll-content-to[data-direction="bottom"]').show();
				}
				if($(_this).find('.scroll-content-to[data-direction="top"]').length == 0) {
					$(_this).prepend('<div class="scroll-content-to" data-direction="top"><span class="glyphicons glyphicons-chevron-up"><span class="line"></span></span><span class="line"></span></div>');
				}
				else {
					$(_this).find('.scroll-content-to[data-direction="top"]').show();
				}
				// styling the scrollbars
				$(_this).find('.scroll-content-to[data-direction="top"] > .line').css({'margin-top': (($('.scroll-content-to[data-direction="top"]').height() / 2) - 2)});
				$(_this).find('.scroll-content-to[data-direction="bottom"] > .line').css({'margin-top': (($('.scroll-content-to[data-direction="bottom"]').height() / 2) - 2)});
				$(_this).find('.scroll-content-to .glyphicons .line').css({'width': '100%', height: '100%'});

				$(_this).find('.scroll-content-to[data-direction="top"]').hide();
				if (sizes.boxContentSize <= sizes.boxSize) {
					$(_this).find('.scroll-content-to[data-direction="bottom"]').hide();
				}
			}
			else if(direction === 'h') {
				/** @todo muss noch geprüft werden wenn nötig */
				if($(_this).find('.scroll-content-to[data-direction="right"]').length == 0) {
					$(_this).append('<div class="scroll-content-to" data-direction="right"><span class="glyphicons glyphicons-chevron-right"><span class="line"></span></span><span class="line"></span></div>')
				}
				if($(_this).find('.scroll-content-to[data-direction="left"]').length == 0) {
					$(_this).prepend('<div class="scroll-content-to" data-direction="left"><span class="glyphicons glyphicons-chevron-left"><span class="line"></span></span><span class="line"></span></div>');
				}
				// styling the scrollbars
				$(_this).find('.scroll-content-to[data-direction="left"] > .line').css({'margin-left': (($('.scroll-content-to[data-direction="left"]').width() / 2) - 2)});
				$(_this).find('.scroll-content-to[data-direction="right"] > .line').css({'margin-right': (($('.scroll-content-to[data-direction="right"]').width() / 2) - 2)});
				$(_this).find('.scroll-content-to .glyphicons .line').css({'width': '100%', height: '100%'});

				$(_this).find('.scroll-content-to[data-direction="left"]').hide();
			}
		}
		else {
			$(_this).find('.scroll-content-to[data-direction="top"]').hide();
			$(_this).find('.scroll-content-to[data-direction="bottom"]').hide();
			$(_this).find('.scroll-content-to[data-direction="left"]').hide();
			$(_this).find('.scroll-content-to[data-direction="right"]').hide();
			if(direction === 'v') {
				$(_this).find('.scroll-content').css('top', 0);
			}
			else if (direction === 'h') {
				$(_this).find('.scroll-content').css('left', 0);
			}
		}
		return this;
	}



	$.fn.setuScrollDetectSizes = function(direction) {
		var _this = this;
		var parentHeight = parseFloat($(this).parent().height());
		var elementsPrev = 0;
		var elementsNext = 0;
		var cssAttr = 'height';

		$(_this).children('ul').addClass('scroll-content');
		if(direction === 'v') {
			elementsPrev = parseFloat($(_this).prev().outerHeight()) + parseFloat($(_this).prev().css('margin-top')) + parseFloat($(_this).prev().css('margin-bottom'));
			elementsNext = parseFloat($(_this).next().outerHeight()) + parseFloat($(_this).next().css('margin-top')) + parseFloat($(_this).next().css('margin-bottom'));
			$(_this).children('.scroll-content').css('width', $(_this).width())
		}
		else if(direction === 'h') {
			elementsPrev = parseFloat($(_this).prev().outerWidth()) + parseFloat($(_this).prev().css('margin-left')) + parseFloat($(_this).prev().css('margin-right'));
			elementsNext = parseFloat($(_this).next().outerWidth()) + parseFloat($(_this).next().css('margin-left')) + parseFloat($(_this).next().css('margin-right'));
			cssAttr = 'width';
			$(_this).children('.scroll-content').css('width', $(_this).height())
		}
		elementsPrev = (elementsPrev >= 0) ? elementsPrev : 0;
		elementsNext = (elementsNext >= 0) ? elementsNext : 0;
		var boxHeight = parentHeight - (elementsPrev + elementsNext);

		$(_this).css(cssAttr, boxHeight);

		return this;
	}


	/**
	 * INITIAL setup
	 *
	 */
	var setuScrollEvent_Uid = 0;
	$.fn.setuScroll = function() {
		var _this = this;
		var eventNamespace = '.setuScroll' + setuScrollEvent_Uid;
		_this.data('setuScrollEventNamespace', eventNamespace);


		var syncSizes = function() {
			var direction = ($(this).attr('data-direction')) ? $(this).attr('data-direction') : 'v';
			_this.setuScrollDetectSizes(direction);
			_this.setuScrollDetectScrollBar(direction);
		}
		$(window).bind('resize' + eventNamespace + ' load' + eventNamespace, syncSizes);

		syncSizes();
		setuScrollEvent_Uid++;
		return this;
	}


	/**
	 * Unbind created events
	 */
	$.fn.setuScrollDestroy = function() {
		var _this = this;

		$(_this).find('.scroll-content-to').remove();
		$(_this).find('.scroll-content').removeAttr('style').removeClass('scroll-content');
		$(_this).removeAttr('style');
		if(!!_this.data('setuScrollEventNamespace')) {
			$(window).unbind(_this.data('setuScrollEventNamespace'));
		}
		return this;
	};

};
setuScroll();
